module.exports = __webpack_public_path__ + "static/media/education-banner.8d74bd17.png";